import React from 'react'
import "./Header.css"
import SearchIcon from '@material-ui/icons/Search';
import HeaderOption from "./HeaderOption.js"
import HomeIcon from '@material-ui/icons/Home';
import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount';
import BusinessCenterIcon from '@material-ui/icons/BusinessCenter';
import NotificationsIcon from '@material-ui/icons/Notifications';
import ChatIcon from '@material-ui/icons/Chat';
import img from "./frlnc).JPG"
import { auth } from './firebase';
import { logout } from './features/userSlice';
import { useDispatch } from 'react-redux';


function Header() {
    
    const dispatch = useDispatch();
    const logoutOfApp = () => {
        dispatch(logout())
        auth.signOut()
    }
    return ( 
    <div className = "header" >
        <div className = "header_left" >
        <img src = "https://image.flaticon.com/icons/png/512/174/174857.png"alt = "" / >
        <div className = "header-search" >
        <SearchIcon / >
        <input type = "text" placeholder = "Search" / >
        </div>   
        </div > 
        <div className = "header_right" >
        <HeaderOption Icon = { HomeIcon } title = "Home" / >
        < HeaderOption Icon = { SupervisorAccountIcon } title = "My network" / >
        <HeaderOption Icon = { BusinessCenterIcon }
        title = "Jobs" / >
        <HeaderOption Icon = { ChatIcon }title = "Messaging" / >
        <HeaderOption Icon = { NotificationsIcon } title = "Notifications" / >
        <HeaderOption avatar = {true} title ="me" onClick={logoutOfApp}/ >  
        </div> 
        </div>
    )
}

export default Header